import React from "react";
import { Loader } from "semantic-ui-react";
import { useCustomQuery } from "utilities/hookutils";
import ArtistButtonList from "./ArtistButtonList";
import ArtistPickerDropdown from "./ArtistPickerDropdown";

interface Props {
  value: server.dto.ArtistSmall
  onChanged: (artist: server.dto.ArtistSmall | undefined) => void
  filter?: server.dto.ArtistPickerFilters
  initialArtistPickerData?: server.dto.ArtistPickerData
  error?: boolean

  excludeKeys?: number[]
  // If no artist is provided, the first artist is selected when it's loaded
  selectFirstArtist?: boolean
  autoFocus?: boolean

}

const ArtistPicker = (props: Props) => {
  if (!props.filter && !props.initialArtistPickerData) {
    throw new Error("Either filter or initialArtistPickerData must be provided");
  }

  const artistApi = useCustomQuery({
    queryFn: async () => {
      const res = await window.Api.Artists.GetArtistPickerData({
        filter: props.filter
      });

      return res.data;
    },
    queryKey: [props.filter],
    enabled: !props.initialArtistPickerData,
    initialData: props.initialArtistPickerData,
    onSuccess: data => {
      if (props.selectFirstArtist && props.value == null && data.artists.length > 0) {
        props.onChanged(data.artists[0]);
      }
    }
  });

  if (artistApi.isLoading) {
    return <Loader active inline size="small" />
  }

  if (artistApi.data.artists.length <= window.serverReference.constants.artistPicker.threshold) {
    return <ArtistButtonList
      allArtists={artistApi.data.artists}
      onChanged={props.onChanged}
      value={props.value}
      error={props.error}
      excludeKeys={props.excludeKeys}
    />;
  }

  return <ArtistPickerDropdown
    allArtists={artistApi.data.artists}
    recentlyUsed={artistApi.data.recentlyUsed}
    onChanged={props.onChanged}
    value={props.value}
    error={props.error}
    excludeKeys={props.excludeKeys}
    autoFocus={props.autoFocus}
  />;
};

export default ArtistPicker;